import { ObjectType } from './../product/shared/models/Enums.enum';
import { ConnectionService } from './../shared/services/connection.service';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MediaService } from '@app/shared/services/Media.service';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';
import { AttributeIdsValue } from '@app/shared/interfaces/AttributeIdsValue';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from '@app/shared/services/layout.service';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { AttributeTypes } from 'src/global-variables';
import { Scope } from '@app/shared/interfaces/Attribute';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { ShowProductsToInherit } from '@product/shared/product-base-logic';
import { FilterLogicService } from '@product/shared/services/filter-logic.service';
import { ProductService } from '@product/shared/services/product.service';
import { Product } from '@product/shared/models/product';
import { Subscription } from 'rxjs';
import { AttributeService } from '@product/shared/services/attribute-service.service';

@Component({
  selector: 'app-bulk-edit',
  templateUrl: './bulk-edit.component.html',
  styleUrls: ['./bulk-edit.component.less'],
})
export class BulkEditComponent extends BaseComponent implements OnInit {

  paginatedAttributSets: any = [];
  currentPage: number = 1;
  pageSize: number = 5;
  totalItmes:number=0;

  // new Var
  selectedAttributeSetId: number | null = null;
  attributeForm: FormGroup;
  selectedAttributeSet: any = {}; 
  additionalAttributes: AttributeIdsValue[] = [];
  attributSets:any;
  sub:Subscription;

  isLoadingData = true; 
  componentModel: PageHeaderComponentModel = {
    backIcon: true,
    breadCrumbPath: [],
    cancelButtonTitle: 'Cancel',
    pageTitle: 'Bulk Edit For Brand',
    refreshButtonTitle: 'Refresh',
    saveButtonTitle: 'Submit Changes',
    editPath: '',
    createPath: '',
    indexPath: '',
    endPoint: '',
    detailsExpandExpression: '',
    objectType: 0,
  };
  formGroup: FormGroup;
  record: any;
  id: number;
  selectedLanguage = 0;
  submitting = false;
  completed = false;
  productInherite: {
    from?: Product;
    to?: Product;
  } = { from: undefined, to: undefined };
  basicProductProps: ModelField[] = [
    {
      Code: 'completionSetId',
      DataType: AttributeTypes.Select,
      Scope: Scope.Global,
      Title: 'Completion Set',
    },
    {
      Code: 'statusId',
      DataType: AttributeTypes.Select,
      Scope: Scope.Global,
      Title: 'Status',
    },
    {
      Code: 'Tags',
      DataType: AttributeTypes.MultiSelect,
      Scope: Scope.Global,
      Title: 'Tags',
    },
    {
      Code: 'InheriteFrom',
      DataType: AttributeTypes.Select,
      Scope: Scope.Global,
      Title: 'Inherite From',
    },
  ];
  dropDownData: { [key: string]: DropDownOption[] } = {};
  constructor(
    injector: Injector,
    private filterLogicService: FilterLogicService,
    private productService: ProductService,
    private attributeService:AttributeService
  
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.initFormAdd();
    this.getAllAttributSets();
    this.formGroup = this.fb.group({
      basicInfo: new FormGroup({}),
      AttributeValues: new FormGroup({}),
      
    });  
    const snapshot = this.route.snapshot;
    this.id = Number(snapshot.paramMap.get('id'));

    this.isLoadingData=true;

    this.connectionService.get(
      `${AppConfigService.settings.dataApiUrl}BulkEditRequest/${this.id}`,
      (response) => {
        try{
          this.record = response;   
          this.isLoadingData=false;          
          this.layoutService.getPageHeaderComponent(
            this.record.ObjectTypeName,
            'edit',
            (d: PageHeaderComponentModel) => {
              this.componentModel = d;
              this.componentModel.pageTitle = `Bulk Edit For ${this.record.ObjectTypeName}`;
            }
          );
        }catch(error){
          console.error('Error load data record:', error);
          this.isLoadingData=false;
        }
       
      }
    );
    this.subscriptions.push(
      this.commonService
        .getOptions()
        .subscribe(
          () => (this.dropDownData = this.commonService.dropDownMetaData)
        )
    );
  }

  override submit() {

    this.submitting = true;
    let attributeIdsValues = {
      ...this.formGroup.controls['AttributeValues'].value,
      ...this.formGroup.get('basicInfo')?.value,
    };
    attributeIdsValues['0.InheriteFrom.from'] = this.productInherite.from?.id;
    attributeIdsValues['0.InheriteFrom'] = this.productInherite.to?.id;

    const request: AttributeIdsValue[] = [];

    Object.keys(attributeIdsValues).forEach((key) => {
      if (key.includes('from')) {
        return;
      }
      const value = attributeIdsValues[key];
      if (value == null) return;
      let fromValue = '';
      if (
        Object.keys(attributeIdsValues).includes(`${key}.from`) &&
        attributeIdsValues[`${key}.from`] != null
      ) {
        fromValue = attributeIdsValues[`${key}.from`].toString();
      }
      if (key.includes('.')) {
        const separatedKey = key.split('.');
        key = separatedKey[1];
      }

      const attributeIdsValue = {
        Id: key,
        AttributeValue: value.toString(),
        FromValue: fromValue,
      };
      request.push(attributeIdsValue);
    });

    // Add data from Form
    Object.keys(attributeIdsValues).forEach((key) => {
      const value = attributeIdsValues[key];
      if (value == null) return;

      let fromValue = '';
      if (key.includes('.from') && attributeIdsValues[`${key}.from`]) {
        fromValue = attributeIdsValues[`${key}.from`].toString();
      }

      const attributeIdsValue = {
        Id: key,
        AttributeValue: value.toString(),
        FromValue: fromValue,
      };
      request.push(attributeIdsValue);
    });
    request.push(...this.additionalAttributes);



    if (request.length == 0) {
      this.message.info('There is nothing to update');
      this.submitting = false;
      return;
    }
    this.connectionService.updateBulkAttribute(
      this.record.Id,
      this.record.ObjectType,
      this.selectedLanguage,
      request,
      (d: any) => {
        this.completed = true;
      }
    );
    // DONT REMOVE THE LINE BELOW
    // this.mediaService.submitMediaBulk$.emit(this.record.ObjectIds);
  }

  languageChanged(newSelectedLanguage: number) {
    this.selectedLanguage = newSelectedLanguage;
  }

  ShowInheritenceProducts(isFrom: boolean) {
    ShowProductsToInherit(
      this.drawerService,
      this.filterLogicService,
      this.productService.getProductsToInherit.bind(this.productService),
      -1
    ).then((product) => {
      if (isFrom) {
        this.productInherite.from = product;
      } else {
        this.productInherite.to = product;
      }
    });
  }
  removeInheritence() {
    // this.product.inheritFromNavigation = undefined;
    // this.product.inheritFrom = undefined;
  }
  get BasicInfoGroup() {
    return this.formGroup.get('basicInfo') as FormGroup;
  }

  goBack() {
    this.router.navigate(['/product/list']); 
  }
  getAllAttributSets(){
    this.sub= this.attributeService.getAttributeSets().subscribe(
      {
       next:(data)=>{
         this.attributSets=data;
         this.totalItmes=this.attributSets.length
         this.updatePaginatedSets();
       },
       error:(error)=>{
 
       }
      }
     )
   }
   onPageChange(page: number): void {
    this.currentPage = page;
    this.updatePaginatedSets();
  }

  updatePaginatedSets(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    //slice(startIndex, startIndex + this.pageSize)
    this.paginatedAttributSets = this.attributSets;
  }
  
  // init From Add attributeSet
  initFormAdd() {
    this.attributeForm = this.fb.group({
      attributeSetId: [null, Validators.required],


    });
  }

  // method Update attributeSet
  setId(attributeSetId: number | null): void {
    if (attributeSetId === null || attributeSetId === undefined) {
      console.warn('attributeSetId is null or undefined');
      this.additionalAttributes = [];
      return;
    }
    this.selectedAttributeSet = this.paginatedAttributSets.find(
      (item: any) => item.id === attributeSetId
    );
  
    if (!this.selectedAttributeSet) {
      console.warn('Selected attribute set not found');
      this.additionalAttributes = [];
      return;
    }
    const attributeData = {
      Id: 'attributeSetId',
      AttributeValue: attributeSetId.toString(),
      //FromValue: attributeSetId.toString() 
    };
    this.additionalAttributes = [attributeData];
  }
  

   override ngOnDestroy(){
    this.sub.unsubscribe();
   }
}
